(() => {
  const banner = document.querySelector('[data-cookie-banner]');
  if (!banner) return;
  let privacy;
  let trackingLoaded = false;
  let returnFocus;
  const error = banner.querySelector('[data-cookie-error]');
  const choices = [...banner.querySelectorAll('[data-cookie-choice]')];

  function startTracking() {
    // Fail closed: the custom tag manager requires explicit consent for both purposes.
    const consent = privacy?.currentVisitorConsent();
    if (trackingLoaded || consent?.analytics !== 'yes' || consent?.marketing !== 'yes' ||
        !privacy.analyticsProcessingAllowed() || !privacy.marketingAllowed()) return;
    trackingLoaded = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-MRJ8DS4K';
    document.head.append(script);
  }

  document.querySelectorAll('[data-cookie-preferences]').forEach((button) => {
    button.addEventListener('click', () => {
      returnFocus = button;
      banner.hidden = false;
      choices[0].focus();
    });
  });
  choices.forEach((button) => button.addEventListener('click', () => {
    if (!privacy) { error.hidden = false; return; }
    choices.forEach((choice) => { choice.disabled = true; });
    error.hidden = true;
    const accept = button.dataset.cookieChoice === 'accept';
    const timeout = window.setTimeout(() => {
      error.hidden = false;
      choices.forEach((choice) => { choice.disabled = false; });
    }, 5000);
    privacy.setTrackingConsent({ analytics: accept, marketing: accept, preferences: accept, sale_of_data: accept }, () => {
      window.clearTimeout(timeout);
      choices.forEach((choice) => { choice.disabled = false; });
      const consent = privacy.currentVisitorConsent();
      if (consent.analytics !== (accept ? 'yes' : 'no')) { error.hidden = false; return; }
      banner.hidden = true;
      returnFocus?.focus();
      if (!accept && trackingLoaded) { window.location.reload(); return; }
      startTracking();
    });
  }));

  if (!window.Shopify?.loadFeatures) return;
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (loadError) => {
    if (loadError || !window.Shopify.customerPrivacy) return;
    privacy = window.Shopify.customerPrivacy;
    const consent = privacy.currentVisitorConsent();
    // Preserve Shopify's native banner as a fallback until this integration works.
    document.documentElement.classList.add('luvly-consent-ready');
    banner.hidden = consent.analytics !== '' && consent.marketing !== '';
    startTracking();
  });
})();
